import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2ba84a",
        secondary: "#2d3a3a",
        anchor: "#fcfffc",
      },
    },
  },
});
